/**
 * @deprecated use same function from '@alilc/lowcode-utils' instead
 */
export function isDOMText(data) {
  return typeof data === 'string';
}